import PropTypes from 'prop-types';
import React, {useMemo, useState} from 'react';
import {sortBy as _sortBy} from 'lodash';
import {useQuery} from '@apollo/client';

import {FiltersWrapper} from '@appComponents/HOCFiltersWrapper';
import {GetCountriesHavingPostalCodesWithSubdivisions} from '@graphql/country/query';
import {CountriesFilter} from '@utils/commonFilters/CountriesFilter';
import {SearchFilter} from '@utils/commonFilters/SearchFilter';
import {SubdivisionsFilter} from '@utils/commonFilters/SubdivisionsFilter';

import {showErrorNotificationMessage} from '../utils/blackoutZone';

export const DEFAULT_FILTERS_VALUES = {
    search: '',
    countries: [],
    countrySubdivisions: [],
};

export const BlackoutZonePostalCodesFilters = ({
    restoreFilterValues: getValue,
    form: {changeValue: setValue},
    filters: {BlackoutZonePostalCodes: filters},
}) => {
    const [countries, setCountries] = useState(getValue(filters, 'countries', [])),
        [countrySubdivision, setCountrySubdivision] = useState(getValue(filters, 'countrySubdivisions', [])),
        [countrySubdivisionOptions, setCountrySubdivisionOptions] = useState([]);

    const onCountryChange = (e, newCountry) => {
        const newCountrySubdivisionOptions = _sortBy(
                countryOptions.filter(co => newCountry.includes(co.id)).flatMap(co => co.country_subdivisions),
                [cs => cs.name]
            ),
            newCountrySubdivision = countrySubdivision.filter(
                csId => newCountrySubdivisionOptions.find(cso => csId === cso.id)
            );

        setCountries(newCountry);
        setValue('countries', newCountry);
        setCountrySubdivision(newCountrySubdivision);
        setCountrySubdivisionOptions(newCountrySubdivisionOptions);
        setValue('countrySubdivisions', newCountrySubdivision);
    };

    const {
        data: {
            countriesHavingPostalCodes: countryOptions = [],
        } = {},
        error: errorFetchingData,
        loading: dataLoading = true,
    } = useQuery(GetCountriesHavingPostalCodesWithSubdivisions, {
        onCompleted: () => onCountryChange(null, countries),
    });

    useMemo(() => {
        (errorFetchingData) && showErrorNotificationMessage();
    }, [errorFetchingData]);

    return (
        <div className='content__filters'>
            <SearchFilter
                loading={dataLoading}
                filters={filters}
                restoreFilterValues={getValue}
            />
            <CountriesFilter
                countries={countryOptions}
                loading={dataLoading}
                onChangeValue={onCountryChange}
                restoreFilterValues={getValue}
            />
            <SubdivisionsFilter
                subdivisions={countrySubdivisionOptions}
                loading={dataLoading}
                filters={filters}
                restoreFilterValues={getValue}
                hidden={0 === countries.length || 0 === countrySubdivisionOptions.length}
                onChangeValue={(e, newCountrySubdivision) => setCountrySubdivision(newCountrySubdivision)}
            />
        </div>
    );
};

BlackoutZonePostalCodesFilters.propTypes = {
    filters: PropTypes.shape({
        BlackoutZonePostalCodes: PropTypes.shape({
            search: PropTypes.string,
            countries: PropTypes.array,
            countrySubdivisions: PropTypes.array,
        }).isRequired,
    }).isRequired,
    restoreFilterValues: PropTypes.func.isRequired,
    form: PropTypes.object.isRequired,
};

export default FiltersWrapper(BlackoutZonePostalCodesFilters, {
    name: 'BlackoutZonePostalCodes',
    initialValues: DEFAULT_FILTERS_VALUES,
});
